/**
 * For reference: https://bulma.io/documentation/modifiers/color-helpers/
 */

import classNames from 'classnames';

export interface IColorModifier {
	// Text Colors
	hasTextWhite?: boolean;
	hasTextBlack?: boolean;
	hasTextLight?: boolean;
	hasTextDark?: boolean;
	hasTextPrimary?: boolean;
	hasTextAi?: boolean;
	hasTextInfo?: boolean;
	hasTextLink?: boolean;
	hasTextSuccess?: boolean;
	hasTextWarning?: boolean;
	hasTextDanger?: boolean;
	hasTextBlackBis?: boolean;
	hasTextBlackTer?: boolean;
	hasTextGreyDarker?: boolean;
	hasTextGreyDark?: boolean;
	hasTextGrey?: boolean;
	hasTextGreyLight?: boolean;
	hasTextGreyLighter?: boolean;
	hasTextWhiteTer?: boolean;
	hasTextWhiteBis?: boolean;

	// Background Colors
	hasBackgroundWhite?: boolean;
	hasBackgroundBlack?: boolean;
	hasBackgroundLight?: boolean;
	hasBackgroundDark?: boolean;
	hasBackgroundPrimary?: boolean;
	hasBackgroundInfo?: boolean;
	hasBackgroundLink?: boolean;
	hasBackgroundSuccess?: boolean;
	hasBackgroundWarning?: boolean;
	hasBackgroundDanger?: boolean;
	hasBackgroundBlackBis?: boolean;
	hasBackgroundBlackTer?: boolean;
	hasBackgroundGreyDarker?: boolean;
	hasBackgroundGreyDark?: boolean;
	hasBackgroundGrey?: boolean;
	hasBackgroundGreyLight?: boolean;
	hasBackgroundGreyLighter?: boolean;
	hasBackgroundWhiteTer?: boolean;
	hasBackgroundWhiteBis?: boolean;
}

export function getColorModifierClasses(modifiers: IColorModifier) {
	return classNames(
		modifiers.hasTextWhite && 'has-text-white',
		modifiers.hasTextBlack && 'has-text-black',
		modifiers.hasTextLight && 'has-text-light',
		modifiers.hasTextDark && 'has-text-dark',
		modifiers.hasTextPrimary && 'has-text-primary',
		modifiers.hasTextAi && 'has-text-ai',
		modifiers.hasTextInfo && 'has-text-info',
		modifiers.hasTextLink && 'has-text-link',
		modifiers.hasTextSuccess && 'has-text-success',
		modifiers.hasTextWarning && 'has-text-warning',
		modifiers.hasTextDanger && 'has-text-danger',
		modifiers.hasTextBlackBis && 'has-text-black-bis',
		modifiers.hasTextBlackTer && 'has-text-black-ter',
		modifiers.hasTextGreyDarker && 'has-text-grey-darker',
		modifiers.hasTextGreyDark && 'has-text-grey-dark',
		modifiers.hasTextGrey && 'has-text-grey',
		modifiers.hasTextGreyLight && 'has-text-grey-light',
		modifiers.hasTextGreyLighter && 'has-text-grey-lighter',
		modifiers.hasTextWhiteTer && 'has-text-white-ter',
		modifiers.hasTextWhiteBis && 'has-text-white-bis',
		modifiers.hasBackgroundWhite && 'has-background-white',
		modifiers.hasBackgroundBlack && 'has-background-black',
		modifiers.hasBackgroundLight && 'has-background-light',
		modifiers.hasBackgroundDark && 'has-background-dark',
		modifiers.hasBackgroundPrimary && 'has-background-primary',
		modifiers.hasBackgroundInfo && 'has-background-info',
		modifiers.hasBackgroundLink && 'has-background-link',
		modifiers.hasBackgroundSuccess && 'has-background-success',
		modifiers.hasBackgroundWarning && 'has-background-warning',
		modifiers.hasBackgroundDanger && 'has-background-danger',
		modifiers.hasBackgroundBlackBis && 'has-background-black-bis',
		modifiers.hasBackgroundBlackTer && 'has-background-black-ter',
		modifiers.hasBackgroundGreyDarker && 'has-background-grey-darker',
		modifiers.hasBackgroundGreyDark && 'has-background-grey-dark',
		modifiers.hasBackgroundGrey && 'has-background-grey',
		modifiers.hasBackgroundGreyLight && 'has-background-grey-light',
		modifiers.hasBackgroundGreyLighter && 'has-background-grey-lighter',
		modifiers.hasBackgroundWhiteTer && 'has-background-white-ter',
		modifiers.hasBackgroundWhiteBis && 'has-background-white-bis'
	);
}
